// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_SgH","cls2":"TranslationModal-cls2__w5 TranslationModal-cls1_SgH"};